import {
    SYMBOLS_FETCH,
    BASE_SYMBOLS_FETCH,
    SYMBOLS_IS_FETCING,
    SYMBOLS_API,
    SYMBOL_EDIT,
    SYMBOL_FILTER,
} from 'constants/symbols'

//HTTP reuests actions
import {
    put,
    post,
    remove,
    get
} from 'actions/requests'

//Save Symbols
export const symbolSave = (data) => (dispatch, state) => {
    let action;
    if (data.symbolId)
        action = put;
    else
        action = post;
    dispatch(symbolsIsFetching(true))
    return action(SYMBOLS_API, data)
        .then((e) => { 
            dispatch(symbolsIsFetching(false))
            return e 
        })
        .catch((e) => { dispatch(symbolsIsFetching(false)); throw new Error(e) })
}

//Feth symbol by id
export const symbolFetch = (id) => (dispatch, state) => {
        dispatch(symbolsIsFetching(true));
        return get(SYMBOLS_API + '/' + id)
            .finally(e => dispatch(symbolsIsFetching(false)))
}

//Feth all symbols
export const symbolsFetch = () => (dispatch, state) => {
    dispatch(symbolsIsFetching(true));
    const filter = state().symbols.pageable
    const sorted = Object.keys(filter.sort).find(e => filter.sort[e])
    return get(SYMBOLS_API, {
            size: filter.size,
            page: filter.page,
            sort: sorted + ',' + filter.sort[sorted]
        })
        .then((e) => {
            dispatch(symbolsFetched(e.content))
            return e
        })
        .then((e) => {
            dispatch(
                symbolFilter({
                    totalPages: e.totalPages
                })
            )
            return e
        })
        //disable loading
        .finally(e => dispatch(symbolsIsFetching(false)))
}

//Feth all symbols
export const baseSymbolsFetch = () => (dispatch, state) => {
    dispatch(symbolsIsFetching(true));
    const filter = state().symbols.pageable
    const sorted = Object.keys(filter.sort).find(e => filter.sort[e])
    return get(SYMBOLS_API, {
            size: filter.size,
            page: filter.page,
            sort: sorted + ',' + filter.sort[sorted],
            onlyBaseSymbols: true
        })
        .then((e) => {
            dispatch(symbolsFetched(e.content))
            return e
        })
        .then((e) => {
            dispatch(
                symbolFilter({
                    totalPages: e.totalPages
                })
            )
            return e
        })
        //disable loading
        .finally(e => dispatch(symbolsIsFetching(false)))
}


export const fetchAllSymbols = () => () => {
    return get(SYMBOLS_API, {
            size: 100000
        })
        .then((e) => {
            return e
        })
}
//Remove one symbol
export const symbolRemove = (id) => (dispatch, state) => {
    dispatch(symbolsIsFetching(true))
    return remove(SYMBOLS_API + '/' + id)
        .finally(e => dispatch(symbolsIsFetching(false)))
}

export const symbolsFetched = (payload) => ({ type: SYMBOLS_FETCH, payload: payload })
export const baseSymbolsFetched = (payload) => ({ type: BASE_SYMBOLS_FETCH, payload: payload })
export const symbolsIsFetching = (payload) => ({ type: SYMBOLS_IS_FETCING, payload: payload })
export const symbolEdit = (id, data) => ({ type: SYMBOL_EDIT, payload: data })
export const symbolFilter = (data) => ({ type: SYMBOL_FILTER, payload: data })


// WEBPACK FOOTER //
// ./src/actions/symbols.js